<template>
    <div class="slides__slide text intro grid-container">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-20 large-12">
                <div class="text-content">
                    <h1>{{ $appdata.introTitle }}</h1>
                    <p>{{ $appdata.introDescription }}</p>

                    <a href="#" class="btn" step="start" @click="$emit('nextStep', {})">{{ $appdata.startButton }}<i class="icon-arrow-right"></i></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
